import ResolveHeader from './ResolveHeader.component';

export default ResolveHeader;